module.exports = __webpack_public_path__ + "img/loader.61c188cc.gif";